import React, { useReducer } from 'react';
import AlertaDispositivoContext from './alertasDispositivoContext';
import AlertaDispositivoReducer from './alertasDispositivoReducer';

import clienteAxios from '../../service/axios';

import {
    ALERTA_DISPOSITIVO_CLEAR_OK,
    ALERTA_DISPOSITIVO_ERROR,
    OBTENER_ALERTAS_DISPOSITIVO,
    ALERTA_OK
} from 'types/context';

const AlertasDispositivoState = props => {
    const initialState = {
        alertasDispositivo: [],
        mensaje: null,
    }

    const [state, dispatch] = useReducer(AlertaDispositivoReducer, initialState);

    // Funciones
    const obtenerAlertasDispositivo = async (estado) => {
        try {
            const respuesta = await clienteAxios.get(`/supervision?estado=${estado ? estado : true}`);

            dispatch({
                type: OBTENER_ALERTAS_DISPOSITIVO,
                payload: respuesta?.data?.supervision?.rows || []
            });

            return respuesta?.data?.supervision?.rows || []

        } catch (error) {
            const alerta = {
                msg: error?.response?.data?.message,
                categoria: 'error'
            }
            dispatch({
                type: ALERTA_DISPOSITIVO_ERROR,
                payload: alerta
            })
        }
    }

    const crearAlertaDispositivo = async (alerta_nueva) => {
        try {
            const respuesta = await clienteAxios.post(`/supervision`, alerta_nueva);
            /* console.log(respuesta); */
            /* dispatch({
                type: OBTENER_ALERTAS_DISPOSITIVO,
                payload: respuesta?.data?.supervision?.rows || []
            }); */
            const alerta = {
                msg: "Aletra creada con exito",
                categoria: 'exito'
            }

            dispatch({
                type: ALERTA_OK,
                payload: alerta
            })

            return /* respuesta?.data?.supervision?.rows || [] */
        } catch (error) {
            const alerta = {
                msg: error?.response?.data?.message,
                categoria: 'error'
            }
            dispatch({
                type: ALERTA_DISPOSITIVO_ERROR,
                payload: alerta
            })
        }
    }

    const editarAlertaDispositivo = async (alerta_edit) => {
        try {
            const respuesta = await clienteAxios.put(`/supervision/${alerta_edit?.id}`, alerta_edit);
            /* dispatch({
                type: OBTENER_ALERTAS_DISPOSITIVO,
                payload: respuesta?.data?.supervision?.rows || []
            }); */
            const alerta = {
                msg: "Aletra modificada con exito",
                categoria: 'exito'
            }

            dispatch({
                type: ALERTA_OK,
                payload: alerta
            })
            return /* respuesta?.data?.supervision?.rows || [] */

        } catch (error) {
            const alerta = {
                msg: error?.response?.data?.message,
                categoria: 'error'
            }
            dispatch({
                type: ALERTA_DISPOSITIVO_ERROR,
                payload: alerta
            })
        }
    }

    const desactivarAlertaDispositivo = async (id) => {
        const alerta = {
            id: id,
            activa: false
        }
        await editarAlertaDispositivo(alerta)
    }

    const activarAlertaDispositivo = async (id) => {
        const alerta = {
            id: id,
            activa: true
        }
        await editarAlertaDispositivo(alerta)
    }

    const eliminarAlertaDispositivo = async (id) => {
        const alerta = {
            id: id,
            activa: false,
            estado: false
        }
        await editarAlertaDispositivo(alerta)
    }

    const clearOk = () => {
        dispatch({
            type: ALERTA_DISPOSITIVO_CLEAR_OK,
            payload: null,
        });
    };

    const clearError = () => {
        dispatch({
            type: ALERTA_DISPOSITIVO_ERROR,
            payload: null,
        });
    };

    return (
        <AlertaDispositivoContext.Provider
            value={{
                clearOkAlertaDispositivo: clearOk,
                clearErrorAlertaDispositivo: clearError,
                alertasDispositivo: state.alertasDispositivo,
                mensaje: state.mensaje,
                obtenerAlertasDispositivo,
                crearAlertaDispositivo,
                desactivarAlertaDispositivo,
                activarAlertaDispositivo,
                eliminarAlertaDispositivo,
                editarAlertaDispositivo
            }}
        >{props.children}

        </AlertaDispositivoContext.Provider>
    )
}
export default AlertasDispositivoState;
